"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _utilities = _interopRequireDefault(require("../../utilities"));
var useGtmLogger = function useGtmLogger(_ref) {
  var fireGtm = _ref.fireGtm,
    gtmContext = _ref.gtmContext,
    apiError = _ref.apiError,
    clientError = _ref.clientError;
  (0, _react.useEffect)(function () {
    if (fireGtm) {
      if (apiError) {
        // Generate and log API error GTM data
        var gtmAPIObj = _utilities.default.createAPIGTMObject(apiError);
        fireGtm(gtmAPIObj);
      }
      if (clientError) {
        // Generate and log Client error GTM data
        var errorObj = _utilities.default.getErrorObj(clientError.translationKey, clientError.descriptionMessage);
        var gtmObj = _utilities.default.createGTMObject(errorObj, gtmContext);
        fireGtm(gtmObj);
      }
    }
  }, [fireGtm, gtmContext, apiError, clientError]);
};
var _default = useGtmLogger;
exports.default = _default;